import { render, staticRenderFns } from "./QuizAttempts.vue?vue&type=template&id=07b28aaa&scoped=true&"
import script from "./QuizAttempts.vue?vue&type=script&lang=js&"
export * from "./QuizAttempts.vue?vue&type=script&lang=js&"
import style0 from "./QuizAttempts.vue?vue&type=style&index=0&id=07b28aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b28aaa",
  null
  
)

export default component.exports